/**
 * Unica puerta de entrada al almacenamiento local. En web usa localStorage;
 * el dia que haya app movil con Capacitor, solo este archivo cambia (a
 * @capacitor/preferences) y el resto del codigo no se entera.
 */
const storage = {
  getItem(key: string): string | null {
    try {
      return window.localStorage.getItem(key)
    } catch {
      return null
    }
  },
  setItem(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value)
    } catch {
      // Almacenamiento no disponible (modo privado, cuota llena): se ignora,
      // Los datos locales no contienen derechos ni precios confirmados.
    }
  },
  removeItem(key: string): void {
    try {
      window.localStorage.removeItem(key)
    } catch {
      // Ver setItem.
    }
  },
}

export default storage
